module.exports = __webpack_public_path__ + "img/gallery-image-1.00016e47.png";